import { IUser } from 'core-components/sitebuilder/models/IUser'

export interface IWidgetData {
  selectedSitePageId: string | null
  userDetailSelectedUser: IUser | null
}

export const createWidgetData = (): IWidgetData => ({
  selectedSitePageId: null,
  userDetailSelectedUser: null,
})
